import { nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import useHighlightsStore from '../stores/highlights';

export const useIframeSelection = () => {
  const { selectedText } = storeToRefs(useHighlightsStore());

  const reapply = async () => {
    const sv = selectedText.value;
    if (!sv?.contents) return;
    try {
      const iframeWindow = sv.contents.window;
      const iframeEl = iframeWindow.frameElement as HTMLElement | null;
      const sel = iframeWindow.getSelection();

      if (sel && sel.rangeCount > 0 && !sel.isCollapsed) {
        // Selection is already valid — focus body synchronously BEFORE nextTick to win the
        // race against the sheet DOM update. Do NOT call iframeEl.focus() first: that causes
        // a transient blur on the body which kills iOS native selection handles.
        sv.contents.document.body.setAttribute('tabindex', '-1');
        sv.contents.document.body.focus({ preventScroll: true });
        return;
      }

      // Selection was lost (e.g. focus stolen on Android/desktop despite retain-focus=false).
      // Wait for DOM to settle then restore programmatically.
      await nextTick();
      const range = sv.contents.range(sv.cfiRange);
      if (!range) return;
      sv.contents.document.body.setAttribute('tabindex', '-1');
      iframeEl?.focus({ preventScroll: true });
      sv.contents.document.body.focus({ preventScroll: true });
      const freshSel = iframeWindow.getSelection();
      if (freshSel) {
        freshSel.removeAllRanges();
        freshSel.addRange(range);
      }
    } catch {
      // CFI-to-range resolution can fail on complex ranges; annotation saves are unaffected
    }
  };

  return { reapply };
};
